import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
} from "@mui/material";
import InvoiceHeaderStyles from "./InvoiceHeaderStyles";
// import { InvoiceData } from "../../constants/invoiceData/InvoiceData";
import { InvoiceDataType } from "../../api/invoice";

const InvoiceHeader: React.FC<{ data?: InvoiceDataType }> = ({ data }) => {
  const styles = InvoiceHeaderStyles;

  const logoURL = localStorage.getItem("logoURL");

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableBody>
          {/* Logo and Header */}
          <TableRow>
            <TableCell sx={styles.logoCell} rowSpan={5}>
              <img
                src={logoURL ?? ""}
                alt="Red Rhino Logo"
                style={{ width: "100%", height: "auto" }}
              />
            </TableCell>
            <TableCell sx={styles.headerCell}>Tax Invoice</TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={styles.subHeaderCell}>
              {data?.company?.name}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={styles.addressCell} data-testid="registered-address">
              <span style={{ fontWeight: 700, fontSize: "9px" }}>
                Registered Address:
              </span>{" "}
              {data?.company?.registeredAddress}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell
              sx={styles.factoryAddressCell}
              data-testid="factory-address"
            >
              <span style={{ fontWeight: 700, fontSize: "9px" }}>
                Factory Address:{" "}
              </span>
              {data?.company?.factoryAddress}
            </TableCell>
          </TableRow>
          {/* Footer Row */}
          <TableRow>
            <TableCell sx={styles.footerCell} colSpan={2}>
              <span style={{ fontWeight: 700, fontSize: "9px" }}>
                Karnataka Tel:
              </span>{" "}
              {data?.company?.tel}
              <span style={{ fontWeight: 700, fontSize: "9px" }}>
                {" "}
                | Email:
              </span>{" "}
              {data?.company?.email}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default InvoiceHeader;
